import { z } from 'zod';
import { TODO_ID_RE, TODO_PROPOSAL_ID_RE } from './ids.js';
export const TODO_STATUSES = ['open', 'in_progress', 'blocked', 'done', 'canceled'];
export const TODO_PRIORITIES = ['low', 'normal', 'high', 'urgent'];
export const TODO_EVENT_ACTIONS = [
    'create',
    'edit',
    'set_status',
    'reorder',
    'snooze',
    'clear_snooze',
    'archive',
    'restore',
];
export const TODO_PROPOSAL_STATUSES = ['pending', 'accepted', 'rejected'];
export const InputLinkSchema = z
    .object({
    url: z.url(),
    label: z.string().trim().min(1).max(200).nullable().default(null),
})
    .strict();
export const TodoSchema = z
    .object({
    kind: z.literal('todo'),
    todo_id: z.string().regex(TODO_ID_RE),
    title: z.string(),
    body_md: z.string(),
    status: z.enum(TODO_STATUSES),
    priority: z.enum(TODO_PRIORITIES),
    due_at: z.string().nullable(),
    remind_at: z.string().nullable(),
    snoozed_until: z.string().nullable(),
    tags: z.array(z.string()),
    links: z.array(InputLinkSchema),
    order: z.number().int(),
    completed_at: z.string().nullable(),
    archived_at: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
})
    .strict();
export const CreateTodoSchema = z
    .object({
    title: z.string().trim().min(1).max(240),
    body_md: z.string().max(40_000).default(''),
    status: z.enum(TODO_STATUSES).default('open'),
    priority: z.enum(TODO_PRIORITIES).default('normal'),
    due_at: z.iso.datetime({ offset: true }).nullable().default(null),
    remind_at: z.iso.datetime({ offset: true }).nullable().default(null),
    tags: z.array(z.string().trim().min(1).max(80)).max(30).default([]),
    links: z.array(InputLinkSchema).max(20).default([]),
})
    .strict();
export const UpdateTodoSchema = z
    .object({
    title: z.string().trim().min(1).max(240).optional(),
    body_md: z.string().max(40_000).optional(),
    status: z.enum(TODO_STATUSES).optional(),
    priority: z.enum(TODO_PRIORITIES).optional(),
    due_at: z.iso.datetime({ offset: true }).nullable().optional(),
    remind_at: z.iso.datetime({ offset: true }).nullable().optional(),
    snoozed_until: z.iso.datetime({ offset: true }).nullable().optional(),
    tags: z.array(z.string().trim().min(1).max(80)).max(30).optional(),
    links: z.array(InputLinkSchema).max(20).optional(),
})
    .strict();
export const TodoEventSchema = z
    .object({
    event_id: z.string().min(1),
    todo_id: z.string().regex(TODO_ID_RE),
    action: z.enum(TODO_EVENT_ACTIONS),
    payload: z.record(z.string(), z.unknown()),
    created_at: z.string(),
})
    .strict();
export const TodoProposalSchema = z
    .object({
    kind: z.literal('todo_proposal'),
    proposal_id: z.string().regex(TODO_PROPOSAL_ID_RE),
    title: z.string(),
    body_md: z.string(),
    rationale_md: z.string().nullable(),
    priority: z.enum(TODO_PRIORITIES),
    due_at: z.string().nullable(),
    tags: z.array(z.string()),
    links: z.array(InputLinkSchema),
    status: z.enum(TODO_PROPOSAL_STATUSES),
    accepted_todo_id: z.string().regex(TODO_ID_RE).nullable(),
    decided_at: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
})
    .strict();
export const ProposeTodoSchema = CreateTodoSchema.pick({
    title: true,
    body_md: true,
    priority: true,
    due_at: true,
    tags: true,
    links: true,
})
    .extend({ rationale_md: z.string().max(12_000).nullable().default(null) })
    .strict();
